__turbopack_context__.v({
  "drawer": "ActionDrawer-module__xwdhQW__drawer",
  "openDrawer": "ActionDrawer-module__xwdhQW__openDrawer",
  "root": "ActionDrawer-module__xwdhQW__root",
});
